import { DtType } from '../generated/graphql';

export const getDtTypeString = (dtType: DtType) => {
  switch (dtType) {
    case DtType.Congressperson:
      return 'US Senators';
    case DtType.EarlyStageVcs:
      return 'Early Stage VCs';
    case DtType.FortuneCeos:
      return 'Fortune 500 CEOs';
    case DtType.NycMayoralCandidate:
      return 'NYC Mayoral Candidate';
    case DtType.Tiktoker:
      return 'Tiktoker';
    case DtType.Sendril:
      return 'Sendril Private Persona';
    case DtType.Influencer:
      return 'Influencer';
    case DtType.FedMember:
      return 'FOMC Members';
    default:
      return 'Unknown';
  }
};
